export default class Fee {
    feeAmount : number
    feeDescription : string
    feeType: FeeType
}

export enum FeeType {
    examFeeMocPrimaryInitial = 2,
    examFeeSubspecialtyinitial = 3,
    examFeeMoc = 4,
    lateFeeInitial = 7,
    lateFeeMoc = 8,
    examFeeMocWithTwoModules = 10,
    examFeeMocWithThreeOrMoreModules = 11,
    ccAnnualFee = 12,
    ccAnnualFeeTwoCertifications = 21,
    ccAnnualFeeThreeOrMoreCertifications = 22,
    annualFeeCredit = 16,
    multipleExamDiscount = 23,
    committeeMemberDiscount = 24,
    committeeMemberTransferFeeDiscount = 25,
    committeeMemberLateFeeDiscount = 26,
    committeeMemberProcessingFeeDiscount = 27
}